import {handleActions} from 'redux-actions';
import {v4 as uuidv4} from 'uuid';
import {
    BLACK_FRAMES_SET,
    BLACK_FRAMES_RESET,
    BlackFramesAction,
} from './BlackFramesActions';
import {TimelineMarker} from '../../../Timeline/TimelineTypes';

export const rowId = uuidv4();

export interface BlackFramesState {
    markers: TimelineMarker[];
    rowId: string;
}

export const setBlackFrames = (state: BlackFramesState, action: BlackFramesAction): BlackFramesState => {
    const {payload} = action;
    
    if (payload) {
        const markers = payload;
        return {
            ...state,
            markers,
        };
    }
    return state;
};

export const resetBlackFrames = (): BlackFramesState => {
    return initialState;
};

export const initialState: BlackFramesState = {
    markers: [],
    rowId,
};

const handlers = {
    [BLACK_FRAMES_SET]: setBlackFrames,
    [BLACK_FRAMES_RESET]: resetBlackFrames,
};

export default handleActions<BlackFramesState, TimelineMarker[]>(handlers, initialState);
